import {ChangeDetectionStrategy, Component, input, model} from '@angular/core';

@Component({
    selector: 'app-section-toggle',
    standalone: true,
    template: `
        <h3 class="fs-6" [class.mb-0]="!expanded()" [class.mb-2]="expanded()">
            <button
                type="button"
                class="section-toggle w-100 d-flex align-items-baseline column-gap-2 border-0 bg-transparent text-start text-body"
                [attr.aria-expanded]="expanded()"
                [attr.aria-controls]="controls()"
                (click)="expanded.set(!expanded())">
                <span class="d-flex align-items-baseline flex-wrap flex-grow-1 column-gap-2">
                    <ng-content />
                </span>
                <i
                    class="bi text-primary flex-shrink-0"
                    [class.bi-chevron-down]="!expanded()"
                    [class.bi-chevron-up]="expanded()"
                    aria-hidden="true"></i>
            </button>
        </h3>
    `,
    styles: `
        .section-toggle {
            padding: var(--section-toggle-padding, 1rem);
        }

        .section-toggle:hover {
            background-color: var(--brunata-blue-faint) !important;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionToggleComponent {
    readonly expanded = model.required<boolean>();
    readonly controls = input.required<string>();
}
